<template>
  <div>
    <Form ref="editModel" :model="editModel" :rules="ruleValidate" :label-width="120" >
      <FormItem label="权限名称" prop="privilegeName">
        <Input  v-model="editModel.privilegeName" placeholder="权限名称必须唯一"></Input>
      </FormItem>
      <FormItem label="权限值" prop="privilegeCode">
        <Input  v-model="editModel.privilegeCode"></Input>
      </FormItem>
      <FormItem label="权限类型" prop="privilegeType">
        <Select  v-model="editModel.privilegeType" clearable>
          <Option
            v-for="(item, index) in privilegeTypeSelect"
            :value="item.value"
            :key="index"
          >{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="描述信息">
        <Input
          v-model="editModel.privilegeDescription"
          type="textarea"
          :autosize="{minRows: 2,maxRows: 5}"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  props:["editModelTemp"],
  components: {},
  data: function () {
    return {
      organParentName: "",
      editModel: {
        PrivilegeID:"",
        privilegeName: "",
        privilegeCode: "",
        privilegeType: "",
        privilegeDescription: "",
      },
      privilegeTypeSelect: [],
      ruleValidate: {
        privilegeName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        privilegeCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        privilegeType: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.privilegeTypeSelect = this.$common.getJsonData("privilegeType");
       this.editModel = this.editModelTemp;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("privilege/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.editModel) {
        this.editModel[key] = "";
      }
      this.$refs["editModel"].resetFields();
    },
  },
};
</script>
<style scoped>
</style>